import React from 'react';
import { Trans } from 'react-i18next';
import { SupportUtils, parseHttpError } from '@cyberint/common-utils';
import {
  INVALID_TOKEN_ERROR,
  INVALID_TOKEN_ERROR_CODE,
  UN_AUTHORIZED_ERROR,
  USER_DISABLED,
  MISSING_ERM_USER_ROLE_ERROR_CODE,
  INSUFFICIENT_ERM_USER_QUOTA_ERROR_CODE
} from '../../utils/embedded-utils';
import * as S from './styled';

const support = () => (
  <a rel="noreferrer" href={SupportUtils.SUPPORT_URL} target="_blank">
    Support
  </a>
);

const GenericError = () => (
  <S.TransWrapper>
    <Trans
      i18nKey="common.infinity.genericError"
      components={{
        h1: <S.Header />,
        small: <S.FooterNote />,
        support: support()
      }}
    />
  </S.TransWrapper>
);

const TokenError = () => (
  <S.TransWrapper>
    <Trans
      i18nKey="common.infinity.tokenError"
      components={{
        h1: <S.Header />
      }}
    />
  </S.TransWrapper>
);

const ErmError = ({ user, tenantId }) => (
  <S.TransWrapper>
    <Trans
      i18nKey="common.infinity.ermError"
      components={{
        h1: <S.Header />,
        small: <S.FooterNote />,
        support: support(user, tenantId)
      }}
    />
  </S.TransWrapper>
);

const QuotaError = () => (
  <S.TransWrapper>
    <Trans
      i18nKey="common.infinity.quotaError"
      components={{
        h1: <S.Header />,
        small: <S.FooterNote />
      }}
    />
  </S.TransWrapper>
);

const UnAuthError = ({ user, tenantId }) => (
  <S.TransWrapper>
    <Trans
      i18nKey="common.infinity.unAuthError"
      components={{
        h1: <S.Header />,
        small: <S.FooterNote />,
        support: support(user, tenantId)
      }}
    />
  </S.TransWrapper>
);

export const getError = ({ e, user, tenantId }) => {
  const errCode = (e?.response?.data || e?.data || e)?.error_code;
  const origError = parseHttpError(e);
  let msg = <GenericError user={user} tenantId={tenantId} />;
  if (origError === INVALID_TOKEN_ERROR || errCode === INVALID_TOKEN_ERROR_CODE) {
    msg = <TokenError />;
  }
  if (origError === UN_AUTHORIZED_ERROR || errCode === USER_DISABLED) {
    msg = <UnAuthError user={user} tenantId={tenantId} />;
  }
  if (errCode === MISSING_ERM_USER_ROLE_ERROR_CODE) {
    msg = <ErmError user={user} tenantId={tenantId} />;
  }
  if (errCode === INSUFFICIENT_ERM_USER_QUOTA_ERROR_CODE) {
    msg = <QuotaError />;
  }

  return { msg, origError };
};

export { Messages } from './Messages';
export { DemoPage } from './DemoPage';
export { ReloadMessage } from './ReloadMessage';
